import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { BRAND } from '../../theme/brandTheme';

/** Register Chart.js once for calculator visualizations */
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export const CHART_COLORS = {
  control: '#6588DF',
  variants: [BRAND.green, '#E57702', '#C73039', '#0E2E96', '#F7BE64'],
  purple: BRAND.purple,
  green: BRAND.green,
  muted: BRAND.textMuted,
};

export const baseChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      labels: { font: { family: BRAND.fontFamily, size: 12 } },
    },
  },
};
